/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.9.12",
    versionName: "0.7.0-nightly.2026.9.12",
    versionChannel: "nightly",
    buildDate: "2026-09-12T00:15:24.001Z",
    commitHash: "30f0fa145d72cff42dd74fa8a8d7a30ef83b0796",
};
